<section>
	<h4 class="lvr-shared-list__title">
		{{ proof().status.content }}
		@if (shouldShowOtherText()) {
			<span> - {{ proof().otherText }}</span>
		}
	</h4>
	<div class="lvr-shared-list__grid">
		<div class="lvr-shared-list__field">
			<span class="lvr-shared-list__field-label">{{ 'client.disability.gbb_value' | transloco }}:</span>
			<span class="lvr-shared-list__field-value">{{ proof().categoryDisabilitySeverity.remark }}</span>
		</div>
		<div class="lvr-shared-list__field">
			<span class="lvr-shared-list__field-label">{{ 'client.disability.dateSbProof' | transloco }}:</span>
			<span class="lvr-shared-list__field-value">{{ proof().since | date: 'dd.MM.yyyy' }}</span>
		</div>
		@if (shouldShowSbStatusDurationInfo()) {
			<div class="lvr-shared-list__field">
				<span class="lvr-shared-list__field-label">{{ 'client.disability.limitedTo' | transloco }}:</span>
				@if (proof().status.limitedUntil) {
					<span class="lvr-shared-list__field-value">{{ proof().status.limitedUntil | date: 'dd.MM.yyyy' }}</span>
				} @else {
					<span class="lvr-shared-list__field-value">{{ 'client.disability.no_limit' | transloco }}</span>
				}
			</div>
		}
		<div class="lvr-shared-list__field">
			<span class="lvr-shared-list__field-label">{{ 'client.disability.documents' | transloco }}:</span>
			@if (proof().documents.length > 0) {
				<ul class="documents-list">
					@for (doc of proof().documents; track doc.id) {
						<li class="btn-link">
							<button type="button" class="documents-list__link btn-link" (click)="openDocument($event, doc)">
								<span class="documents-list__name">{{ doc.name }}</span>
							</button>
						</li>
					}
				</ul>
			} @else {
				<span class="lvr-shared-list__field-value">-</span>
			}
		</div>
	</div>
</section>
